import { VhQueryAutoWeb, VhEventMediator, VhAlgorithm } from 'vhautowebdb';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FunctionService } from 'vhobjects-service';

@Component({
  selector: 'app-select-language-config',
  templateUrl: './select-language-config.component.html',
  styleUrls: ['./select-language-config.component.scss']
})
export class SelectLanguageConfigComponent implements OnInit {
  @Output() handleChangeMultiLanguage = new EventEmitter<string>();
  /** Để xác định trang đang hiển thị là trang `Admin` hay không. 
   * 
   * Nếu là `Admin` thì khi thay đổi Ngôn ngữ được chọn sẽ `KHÔNG` bắn notify `this.vhEventMediator.notifyOnConfigChanged({ status: 'update-language', code: newLanguage });` 
   */
  @Input() isAdmin: any;
  @Input() displayLabel: any;
  @Input() isSetLanguageCode: any = false; //giá trị boolean để kiểm tra xem có cần set lại languagecode ở localStorage không
  @Input() languages: any;
  // languages:any=[]
  isDropdownOpen = false;

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private VhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private vhAlgorithm: VhAlgorithm
  ) { }

  ngOnInit() {
    if(!this.functionService.multi_languages?.length) {
      this.vhQueryAutoWeb.getSetups_byFields({ type: { $eq: 'multi_languages'}}).then((res: any) => {
        if(res.length==0) return;
        this.languages = res[0]?.multi_languages ?? [];
        if(!this.vhQueryAutoWeb.localStorageGET('language_code')?.code) {
          this.vhQueryAutoWeb.localStorageSET('language_code', {code: res[0].multi_languages[0].code});
          this.functionService.selectedLanguageCode = res[0].multi_languages[0].code;
          this.functionService.multi_languages = res[0].multi_languages;
        }
      })
    } else this.languages = this.functionService.multi_languages
    // this.getLanguage()
  }

  languageChangedSubscription
  ngAfterViewInit(): void {
    this.languageChangedSubscription = this.VhEventMediator.configChanged.subscribe((message: any) => {
      if (message?.status === 'update-setup-language') {
        this.languages= message?.multi_languages
        this.functionService.selectedLanguageCode = this.vhQueryAutoWeb.localStorageGET('language_code')?.code;
      }
    });
  }

  ngOnDestroy() {
    this.languageChangedSubscription?.unsubscribe();
  }

  getLanguage(){
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $eq: 'multi_languages'}}).then((res: any) => {
      if(res.length==0) return;
      this.languages = res[0]?.multi_languages ?? [];
      if(!this.vhQueryAutoWeb.localStorageGET('language_code')?.code) {
        this.vhQueryAutoWeb.localStorageSET('language_code', {code: res[0].multi_languages[0].code});
        this.functionService.selectedLanguageCode = res[0].multi_languages[0].code;
      }
    })
  }

  onLanguageChange(language: any): void {
    // nếu cần set lại languageCode ở local_storage
    if(this.isSetLanguageCode){
      this.functionService.selectedLanguageCode = language.code;
      this.vhQueryAutoWeb.localStorageSET('language_code', {code: language.code});
      this.VhEventMediator.notifyOnConfigChanged({ status: 'update-language', code: language.code });
      this.handleChangeMultiLanguage.emit(language.code)
    }
    this.functionService.languageTempCode = language.code;
    this.isDropdownOpen = false;
  }


  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // Đóng dropdown khi click ra ngoài
  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    const targetElement = event.target as HTMLElement;
    if (!targetElement.closest('.dropdown-container')) {
      this.isDropdownOpen = false;
    }
  }
}
